module.exports = __webpack_public_path__ + "img/quizz-step-8-5.f85239a7.jpg";